<template>
    <div @click="$emit('input', !value)" class="cielo-radio" :class="{selected: value}" />
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                required: false
            }
        }
    };
</script>

<style lang="scss" scoped>
    .cielo-radio {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        width: 24px;
        height: 24px;
        border: 1.5px solid #B8C1CC;
        border-radius: 24px;
        transition: all .3s ease-in-out;
        
        &.selected,
        &:hover {
          border-color: #0774E7;

          &::after {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50% , -50%);
            width: 12px;
            height: 12px;
            border-radius: 16px;
            background-color: #0774E7;
          }
        }
    }
</style>
